import { render, staticRenderFns } from "./LicenseCard.vue?vue&type=template&id=699fb9c8&scoped=true&"
import script from "./LicenseCard.vue?vue&type=script&lang=js&"
export * from "./LicenseCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699fb9c8",
  null
  
)

export default component.exports